class GA4 {
  static GTAGID = 'GTM-M2VKWGM' //G-X89XH9DM49'
}

export default GA4
